import { ReactNode, useEffect } from "react";

import { ActivityType } from "__graphql__/types";
import { restockingActivityCoordinator } from "flows/Activities/coordinator/restockingActivityCoordinator";
import { usePublishActivityStatusChanged } from "flows/Activities/hooks/usePublishActivityStatusChanged";
import { useRestockingServiceStore } from "flows/Inventory/flows/RestockingList/stores/restockingServiceStore";

type RestockingActivityTrackerProps = {
  children: ReactNode;
};

export function RestockingActivityTracker({ children }: RestockingActivityTrackerProps) {
  const { publishActivityStatusStart, publishActivityStatusEnd } = usePublishActivityStatusChanged(
    ActivityType.restocking,
  );

  useEffect(() => {
    restockingActivityCoordinator.start(publishActivityStatusStart, publishActivityStatusEnd);
    return () => {
      const isNavigatingToStockCorrection =
        useRestockingServiceStore.getState().isNavigatingToStockCorrection;
      if (isNavigatingToStockCorrection) return;
      restockingActivityCoordinator.end();
    };
    // eslint-disable-next-line react-compiler/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>{children}</>;
}
